<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs3-08",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 49,
      nextPage: '/questionnaire/section3/9',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'longBtn'
        },
        mainTitle: 'How often do you smoke?',
        btn: [
          [
            {
              text: 'Never smoke',
            }
          ],[
            {
              text: '1 to 2 packs a week',
              operation: 'flag1-4_Prepare_add reminder 4 & flag1-4_Menopause_add reminder 13'
            }
          ],[
            {
              text: 'Half a pack to pack a day',
              operation: 'flag1-4_Prepare_add reminder 4 & flag1-4_Menopause_add reminder 13'
            }
          ],[
            {
              text: 'Over 1 pack a day on average',
              operation: 'flag1-4_Prepare_add reminder 4 & flag1-4_Menopause_add reminder 13'
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
